import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { lsGet, lsSet } from '../lib/storage';

const NUDGE_KEY  = 'diwanUpdateNudgeDismissed';
const CYCLE_MS   = 21 * 24 * 60 * 60 * 1000;

function isDue() {
  const last = parseInt(lsGet(NUDGE_KEY) || '0', 10);
  return Date.now() - last > CYCLE_MS;
}

export default function UpdateNudge() {
  const { pathname, search, hash } = useLocation();
  const inAuthFlow =
    pathname.startsWith('/auth/') ||
    pathname.startsWith('/reset-password') ||
    search.includes('code=') ||
    hash.includes('access_token');

  const [visible, setVisible] = useState(isDue);

  // iOS bfcache: page is restored from memory instead of remounting React,
  // so useState initialiser never re-runs. Re-check localStorage on pageshow.
  useEffect(() => {
    function onPageShow(e) {
      if (e.persisted) setVisible(isDue());
    }
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, []);

  if (!visible || inAuthFlow) return null;

  function dismiss() {
    lsSet(NUDGE_KEY, String(Date.now()));
    setVisible(false);
  }

  function refresh() {
    lsSet(NUDGE_KEY, String(Date.now()));
    // Replace href instead of reload() to bypass iOS bfcache restore
    window.location.replace(window.location.href);
  }

  return (
    <div style={{
      position: 'fixed',
      top: 'calc(env(safe-area-inset-top, 0px) + 0.55rem)',
      left: '50%',
      transform: 'translateX(-50%)',
      width: 'min(calc(100% - 2rem), 400px)',
      background: 'var(--bg2)',
      border: '1px solid var(--gold-line)',
      borderRadius: 8,
      padding: '0.65rem 0.9rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      zIndex: 999,
      boxShadow: '0 4px 20px rgba(0,0,0,0.35)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      animation: 'slideDown 0.3s ease',
    }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontFamily: "'Cinzel', serif",
          fontSize: '0.48rem',
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          color: 'var(--gold)',
          marginBottom: '0.15rem',
        }}>
          Al-Diwan
        </div>
        <div style={{
          fontFamily: "'Libre Baskerville', Georgia, serif",
          fontSize: '0.72rem',
          color: 'var(--text)',
          lineHeight: 1.4,
        }}>
          New features are live — stay up to date
        </div>
      </div>

      <button
        onClick={refresh}
        style={{
          flexShrink: 0,
          background: 'var(--gold)',
          color: '#fff',
          border: 'none',
          borderRadius: 5,
          padding: '0.35rem 0.75rem',
          fontFamily: "'Josefin Sans', sans-serif",
          fontSize: '0.52rem',
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        Refresh
      </button>

      <button
        onClick={dismiss}
        aria-label="Dismiss"
        style={{
          flexShrink: 0,
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--text3)',
          fontSize: '1rem',
          lineHeight: 1,
          padding: '0.2rem',
          opacity: 0.6,
        }}
      >×</button>
    </div>
  );
}
